export function getLocalized<T extends Record<string, unknown>>(obj: T | undefined, locale: string): T[keyof T] | null {
  return (obj?.[locale as keyof T] ?? null) as T[keyof T] | null;
}
